import { Modal } from '../../interfaces/utils-interfaces';
import styles from './modal.module.scss';

export default function ModalShop(props: { closePopup: any, actionbutton1: any, actionbutton2?: any, modalText: Modal }) {
    return (
        <div className={styles["modal"]}>
            <div className={styles["modal-content"]}>
                <div className={styles["modal-header"]}>
                    <span className={styles["close"]} onClick={props.closePopup}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="28.964" height="28.964" viewBox="0 0 28.964 28.964">
                            <path className={styles["icon-close"]} d="M7.822,5.085A1.936,1.936,0,0,0,5.085,7.822L16.263,19,5.085,30.178a1.936,1.936,0,0,0,2.737,2.737L19,21.737,30.177,32.915a1.936,1.936,0,1,0,2.737-2.737L21.737,19,32.915,7.822a1.936,1.936,0,0,0-2.737-2.737L19,16.263Z" transform="translate(-4.518 -4.518)" fill="#fff" />
                        </svg>
                    </span>
                    <p>{props.modalText.title}</p>
                </div>
                <div className={styles["modal-body"]}>
                    <p>{props.modalText.subtitle}</p>
                </div>
                <div className={styles["modal-footer"]}>
                    <p>{props.modalText.question}</p>
                    {props.modalText.button2 !== undefined && <div className={`${styles['modal-button']} ${styles['highlight']}`} onClick={props.actionbutton2}>
                        <p>{props.modalText.button2}</p>
                    </div>}
                    <div className={styles["modal-button"]} onClick={props.actionbutton1}>
                        <p>{props.modalText.button1}</p>
                    </div>

                </div>
            </div>

        </div>
    );
}